import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        // Si el usuario no está autenticado, redirige a la página de login
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute;
